module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Sad-3a47274a04141f5827642532e3368b88.svg";